let downloadSessionGeneration = 0;

export function bumpDownloadSessionGeneration(): void {
  downloadSessionGeneration += 1;
}

export function getDownloadSessionGeneration(): number {
  return downloadSessionGeneration;
}

let activeSessionJobId: string | null = null;

export function setSessionActiveJobId(jobId: string | null): void {
  activeSessionJobId = jobId;
}

export function getSessionActiveJobId(): string | null {
  return activeSessionJobId;
}
